import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataRequest, DataRequestByPage, PaginationResponse } from 'src/app/interfaces/base-entity';

@Injectable({
    providedIn: 'root'
})
export class GenericService<T> {
    private apiUrl: string = '';

    constructor(public http: HttpClient) {}

    setApiUrl(url: string): void {
        this.apiUrl = url;
    }

    getAll(): Observable<T[]> {
        return this.http.get<T[]>(`${this.apiUrl}/getAll`);
    }

    getAllByFilter(dataRequest: DataRequest = { filters:[], sorts: []}): Observable<T[]> {
        return this.http.post<T[]>(`${this.apiUrl}/getAllByFilter`,dataRequest);
    }

    getAllByPosition(positionId: number): Observable<T[]> {
        return this.http.post<T[]>(`${this.apiUrl}/getAllByPosition/${positionId}`, {});
    }


    getAllByPage(rows: number, position: number, dataRequest: DataRequestByPage = { filters:[], sorts: []}): Observable<PaginationResponse<any>> {
        dataRequest.position = position;
        dataRequest.rows = rows;
        return this.http.post<PaginationResponse<any>>(`${this.apiUrl}/getAllByPage`,dataRequest);
    }  
    
   

    getById(id: number): Observable<T> {
        return this.http.get<T>(`${this.apiUrl}/getById/${id}`);
    }

    create(item: T): Observable<T> {
        return this.http.post<T>(`${this.apiUrl}/save`, item);
    }

    update(id: number, item: T): Observable<T> {
        return this.http.put<T>(`${this.apiUrl}/update/${id}`, item);
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/delete/${id}`);
    }
}